import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Style from "./loading-page-styles";
import Spinner from "../Spinner";

export default function LoadingPage({ init }) {
  const classes = Style();

  useEffect(() => { if(init) init() }, [init]);

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item xs className={classes.content}>
        <Box className={classes.spinBox}>
          <Spinner open />
        </Box>
      </Grid>
    </Grid>
  );
}
